import React from 'react';
import Page from './Page/Page';

const Error404 = () => (
  <div className="Error404">
    <Page>
      <p>
        You appear to be looking for a page that does not exist on our site. You may have typed an incorrect URL in your
        browser or perhaps we moved or deleted this page.
      </p>
      <p>
        From here you can navigate elsewhere using the menu above or visit the <a href="/">home page</a>.
      </p>
      <p>
        If you're sure you typed the URL correctly, please <a href="/public/contact-us.action">let us know</a>
        &nbsp;so we can fix the problem.
      </p>
    </Page>
  </div>
);

export default Error404;

